import React from "react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  label: string;
  dark?: boolean;
  note?: string;
};
export function SectionCta({
  label,
  dark = false,
  note = "Immediate Digital Access · One-Time Payment of $27 USD · Lifetime Access"
}: SectionCtaProps) {
  return <div className="mx-auto mt-12 flex max-w-xl flex-col items-center gap-3 text-center" data-id="element-65" data-mp="3nc0aizgv8raj">
      <CtaButton label={label} data-id="element-66" data-mp="38nvopmminznj" />
      <p className={`text-xs font-medium sm:text-sm ${dark ? "text-white/70" : "text-ink-muted"}`} data-id="element-67" data-mp="38mu4arjm20t5">{note}</p>
    </div>;
}